import { FormControlLabel } from '@mui/material';
import styled from 'styled-components';

const StyledFormControlLabel = styled(FormControlLabel)`
  width: 250px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 60px;
  margin-bottom: 30px;
  height: 20px;
`;

const Error = styled.div`
  margin-bottom: 40px;
`;

export { StyledFormControlLabel, Error };
